export function createLenderRevalidationPlugin() {
  return function lenderRevalidationPlugin(node) {
    if (node.props.type !== 'lender-autocomplete') return

    let lastValue = node.value

    node.on('commit', ({ payload }) => {
      if (payload === lastValue) return
      lastValue = payload

      const lenderName = node.name
      const root = node.at('$root') || node

      root.walk((other) => {
        if (other === node) return
        const validation = other.props?.validation
        if (typeof validation !== 'string') return
        if (!validation.includes(lenderName)) return
        other.input(other.value, false)
      })
    })
  }
}
